module.exports = __webpack_public_path__ + "img/127.1.aa3b00e6.jpg";